import { ActiveStep } from "Components/ActiveStep";
import { AdviceAuthorizedIcon } from "Components/AdviceAuthorizationIcon/AdviceAuthorizedIcon";
import { AdviceDialog } from "Components/AdviceDialog/AdviceDialog";
import { Authenticated } from "Components/Authenticated";
import { ProductTile } from "Components/Features/CheckPrice/Tiles/ProductTile";
import { useTexts } from "Components/TextContext";
import { ProtectedRoute } from "Router/ProtectedRoute";
import { AdviceVersion } from "Store/akaAdvice/akaAdviceHooks";
import { setCheckPriceProducts } from "Store/analytics/analyticsSlice";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  ADVICE_ABOUT_YOU_STEP,
  ADVICE_PRICE_STEP,
  ADVICE_STEPS,
  ADVICE_YOUR_LIFE_SITUATION_STEP,
  PRODUCT_PATH,
} from ".";
import { ProductBackendName } from "../productTypes";
import { ProductDetails } from "./ProductDetails";
import { ProductIntro } from "./ProductIntro";
import { ProductPrice } from "./ProductPrice";
import { ProductPriceAka } from "./ProductPriceAka";
import {
  useAdviceStartStep,
  useAdviceStateCleanup,
  useAdviceVersion,
  useBlockAdvisorCartDialog,
} from "./hooks";

export const Advice = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { getText } = useTexts();
  const startStepId = useAdviceStartStep();
  const editBlockerDialogProps = useBlockAdvisorCartDialog();
  const adviceVersion = useAdviceVersion();

  useAdviceStateCleanup();

  useEffect(() => {
    dispatch(setCheckPriceProducts([ProductBackendName.ADVICE]));
  }, []);

  return (
    <>
      <ProductTile
        title={getText("insuranceproduct.advice.name")}
        productName={getText("insuranceproduct.advice.name")}
        productBackendName={ProductBackendName.ADVICE}
        productPath={PRODUCT_PATH}
        productSteps={ADVICE_STEPS}
        shouldSkipLoginStep={false}
        startProductStepId={startStepId}
      >
        <ProtectedRoute
          exact
          path={`${PRODUCT_PATH}/${ADVICE_ABOUT_YOU_STEP.id}`}
          render={() => (
            <ActiveStep>
              <Authenticated>
                <ProductIntro />
              </Authenticated>
            </ActiveStep>
          )}
        />
        <ProtectedRoute
          exact
          path={`${PRODUCT_PATH}/${ADVICE_YOUR_LIFE_SITUATION_STEP.id}`}
          render={() => (
            <ActiveStep>
              <Authenticated>
                <ProductDetails />
              </Authenticated>
            </ActiveStep>
          )}
        />
        <ProtectedRoute
          exact
          path={`${PRODUCT_PATH}/${ADVICE_PRICE_STEP.id}`}
          render={() => (
            <ActiveStep>
              <Authenticated>
                {adviceVersion === AdviceVersion.OLD ? (
                  <ProductPrice />
                ) : (
                  <ProductPriceAka />
                )}
              </Authenticated>
            </ActiveStep>
          )}
        />
      </ProductTile>
      <AdviceDialog {...editBlockerDialogProps} />
      <AdviceAuthorizedIcon />
    </>
  );
};
